import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import HandbookChapter from './HandbookChapter.vue';
let HandbookCasting = class HandbookCasting extends Vue {
};
HandbookCasting = __decorate([
    Component({
        components: {
            HandbookChapter
        }
    })
], HandbookCasting);
export default HandbookCasting;
